<div
  id="forgot-password"
  class="inner-scroll"
  fxLayout="row"
  fxLayoutAlign="start"
>
  <app-wellcome />
  <div
    id="forgot-password-form-wrapper"
    [@animate]="{ value: '*', params: { delay: '300ms', x: '100%' } }"
  >
    <div id="forgot-password-form">
      <div class="logo" fxHide.gt-xs>
        <img src="assets/images/logos/fuse.svg" />
      </div>
      <div class="title">RECUPERAR CONTRASEÑA</div>
      <div *ngIf="isForm">
        <form
          name="forgoPasswordForm"
          autocomplete="off"
          [formGroup]="forgotPasswordForm"
          (submit)="onSubmit()"
          novalidate
        >
          <div [hidden]="!isFiltroSeguridad">
            <span
              fxLayout="column"
              fxLayoutAlign="center center"
              class="disabled-text"
              >{{ cardIdFormatted }}</span
            >
          </div>
          <div [hidden]="!isFiltroSeguridad">
            <h5 class="text-success">Filtro de seguridad</h5>
            <mat-form-field appearance="outline">
              <mat-label>Color</mat-label>
              <mat-select autocomplete="color" formControlName="color" required>
                <mat-option
                  [value]="color.value"
                  *ngFor="let color of colores"
                  >{{ color.text }}</mat-option
                >
              </mat-select>
              <mat-icon
                matSuffix
                class="secondary-text"
                [matTooltip]="getColorErrorTooltip()"
                [ngClass]="{ 'error-icon': hasColorError() }"
                >security</mat-icon
              >
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Mascota</mat-label>
              <mat-select
                autocomplete="mascota"
                formControlName="mascota"
                required
              >
                <mat-option
                  [value]="mascota.value"
                  *ngFor="let mascota of mascotas"
                  >{{ mascota.text }}
                </mat-option>
              </mat-select>
              <mat-icon
                matSuffix
                class="secondary-text"
                [matTooltip]="getMascotaErrorTooltip()"
                [ngClass]="{ 'error-icon': hasMascotaError() }"
                >security</mat-icon
              >
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Fruta</mat-label>
              <mat-select autocomplete="fruta" formControlName="fruta" required>
                <mat-option
                  [value]="fruta.value"
                  *ngFor="let fruta of frutas"
                  >{{ fruta.text }}</mat-option
                >
              </mat-select>
              <mat-icon
                matSuffix
                class="secondary-text"
                [matTooltip]="getFrutaErrorTooltip()"
                [ngClass]="{ 'error-icon': hasFrutaError() }"
                >security</mat-icon
              >
            </mat-form-field>
          </div>
          <div *ngIf="isSendMail" class="register-confirm mat-m2">
            <h4>Hemos enviado un email al siguiente correo electronico:</h4>
            <h4>{{ email }}</h4>
            <div *ngIf="!isFilterReset">
              <a (click)="onSubmit()"
                >No has recibido enlace, volver a enviarlo</a
              >
            </div>
          </div>
          <div [hidden]="!isFiltroSeguridad">
            <button
              mat-raised-button
              color="accent"
              class="submit-button"
              aria-label="SEND RESET LINK"
              [disabled]="!formValid() || loading"
              *ngIf="!isSendMail"
            >
              <span *ngIf="!loading">ACEPTAR</span>
              <div class="loadingComponent" *ngIf="loading">
                <app-loading [isLoading]="loading" />
              </div>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="footer">Nubyy 2019, Todos los derechos reservados.</div>
  </div>
</div>
